type ScrollerCtor = new (
  canvasScroller: any,
  samples: number[][],
  config: any,
  prevChanIdx: number,
) => any;

let ScrollerImpl: any;

(function () {
  ScrollerImpl = function (
    canvasScroller: any,
    samples: number[][] = [[], [], []],
    config: any,
    prevChanIdx: number,
  ) {
    this.canvasScroller = canvasScroller;
    this.config = config;
    this.borderWidth = 3;
    this.scrollerGraphColor = '#000';
    this.borderColor = '#0954BA';
    this.selectionRangeColor = 'rgba(9, 84, 186, 0.25)';
    this.selectionRangeHoverColor = 'rgba(9, 84, 186, 0.65)';
    this.scrollerGraphWidth = 1.3;
    this.numberOfVisibleChannels = 1;
    this.wndDuration = this.config.recDuration;
    this.gain = this.config.gain * 2;
    this.ctxScroller = canvasScroller.getContext('2d');

    this.recalculateScaleFactors();

    this.prepareAllPixelSamples(samples[prevChanIdx]);
  };

  ScrollerImpl.prototype.draw = function (offsetX: number, isHover: boolean) {
    this.canvasScroller.clear();

    this.drawBorder();
    this.drawSelectionRange(offsetX, isHover);
    this.drawScrollerChart();
  };

  ScrollerImpl.prototype.drawBorder = function () {
    const { width, scrollerHeight } = this.config;
    this.ctxScroller.beginPath();
    this.ctxScroller.lineWidth = this.borderWidth;
    this.ctxScroller.strokeStyle = this.borderColor;
    this.ctxScroller.moveTo(0, 0);
    this.ctxScroller.lineTo(0, scrollerHeight);
    this.ctxScroller.lineTo(width, scrollerHeight);
    this.ctxScroller.lineTo(width, 0);
    this.ctxScroller.lineTo(0, 0);
    this.ctxScroller.stroke();
    this.ctxScroller.closePath();
  };

  ScrollerImpl.prototype.drawScrollerChart = function () {
    this.ctxScroller.beginPath();
    this.ctxScroller.lineWidth = this.scrollerGraphWidth;
    this.ctxScroller.strokeStyle = this.scrollerGraphColor;
    const samplesLength = this.samples.length;
    for (let j = 0; j < samplesLength - 1; j += 1) {
      this.ctxScroller.moveTo(this.samples[j].x, this.samples[j].y);
      this.ctxScroller.lineTo(this.samples[j + 1].x, this.samples[j + 1].y);
    }
    this.ctxScroller.stroke();
    this.ctxScroller.closePath();
  };

  ScrollerImpl.prototype.drawSelectionRange = function (offsetX = 0, isHover: boolean) {
    const { scrollerHeight, sampleLength, width } = this.config;

    this.startX = (offsetX * width) / sampleLength;

    this.ctxScroller.beginPath();
    this.ctxScroller.fillStyle = isHover ? this.selectionRangeHoverColor : this.selectionRangeColor;
    this.ctxScroller.moveTo(this.startX, 0);
    this.ctxScroller.lineTo(this.startX, scrollerHeight);
    this.ctxScroller.lineTo(this.startX + this.xRange, scrollerHeight);
    this.ctxScroller.lineTo(this.startX + this.xRange, 0);
    this.ctxScroller.lineTo(this.startX, 0);
    this.ctxScroller.fill();
    this.ctxScroller.closePath();
  };

  ScrollerImpl.prototype.recalculateScaleFactors = function () {
    const { width, speed, samplingRate } = this.config;

    this.aspectRatioX = width / this.wndDuration / speed;
    this.aspectRatioY = this.aspectRatioX;
    this.secondsToPix = speed * this.aspectRatioX;
    this.indexToPix = (speed * this.aspectRatioX) / samplingRate;
    this.majorDivSize = width / this.wndDuration;
    this.millivoltToPix = this.gain * this.aspectRatioY;
    this.xRange = this.config.wndDuration * this.secondsToPix;
  };

  ScrollerImpl.prototype.prepareAllPixelSamples = function (physSamples: number[]) {
    const { scrollerHeight, width } = this.config;
    const self = this;
    this.verticalChannelPlacement = [];
    for (let chIdx = 0; chIdx < physSamples.length; chIdx += 1) {
      this.verticalChannelPlacement.push(
        (scrollerHeight / this.numberOfVisibleChannels) * (chIdx + 0.5),
      );
    }
    // this.verticalChannelPlacement = physSamples.map((chArr, chIdx) => scrollerHeight / this.numberOfVisibleChannels * (chIdx + 0.5));
    const bucketSize = Math.floor(physSamples.length / width);
    const decimatedArr = this.decimateSamples(physSamples, bucketSize);
    this.samples = [];
    for (let i = 0; i < decimatedArr.length; i += 1) {
      this.samples.push({
        x: Math.floor(i * bucketSize * self.indexToPix),
        y: Math.floor(self.verticalChannelPlacement[0] - decimatedArr[i] * this.millivoltToPix),
      });
    }
    // this.samples = decimatedArr.map((u, i) => ({
    //   x: Math.floor(i * bucketSize * self.indexToPix),
    //   y: Math.floor(self.verticalChannelPlacement[0] - u * this.millivoltToPix),
    // }));
  };

  ScrollerImpl.prototype.decimateSamples = function (samples: number[], bucketSize: number) {
    let decimatedArr: number[] = [];
    if (bucketSize > 1) {
      const samplesLength = samples.length;
      for (let i = 0; i <= samplesLength - bucketSize; i += bucketSize) {
        const bucket = samples.slice(i, i + bucketSize);
        const max = Math.max.apply(null, bucket);
        const min = Math.min.apply(null, bucket);
        const prevSelected = i === 0 ? 0 : decimatedArr[decimatedArr.length - 1];
        const selectedVal = Math.abs(prevSelected - max) > Math.abs(prevSelected - min) ? max : min;
        decimatedArr.push(selectedVal);
      }
    } else {
      decimatedArr = samples;
    }
    return decimatedArr;
  };

  ScrollerImpl.prototype.update = function (samples: number[][], config: any, prevChanIdx: number) {
    this.config = config;
    this.wndDuration = this.config.recDuration;
    this.xRange = this.config.wndDuration * this.secondsToPix;
    this.gain = this.config.gain * 2;

    this.recalculateScaleFactors();

    this.prepareAllPixelSamples(samples[prevChanIdx]);
  };

  ScrollerImpl.prototype.updatePrevChanIdx = function (
    samples: number[][],
    offsetX: number,
    prevChanIdx: number,
  ) {
    this.prepareAllPixelSamples(samples[prevChanIdx]);

    this.draw(offsetX, false);
  };

  ScrollerImpl.prototype.checkClickInsideSelectionRange = function (
    xPoint: number,
    yPoint: number,
  ) {
    const { scrollerHeight } = this.config;
    if (
      xPoint >= this.startX &&
      xPoint <= this.startX + this.xRange &&
      yPoint >= 0 &&
      yPoint <= scrollerHeight
    ) {
      return true;
    }
    return false;
  };
})();

const Scroller: ScrollerCtor = ScrollerImpl;

export { Scroller };
export default { Scroller };
